import type { LucideIcon } from 'lucide-react';

export function FeatureToggle({
  enabled,
  label,
  icon: Icon,
  onClick,
  disabled,
}: {
  enabled: boolean;
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={enabled}
      title={`${label}: ${enabled ? 'on' : 'off'}`}
      className={
        enabled
          ? 'inline-flex items-center gap-1 rounded-full bg-felt-50 px-2.5 py-1 text-xs font-medium text-felt-900 transition hover:bg-felt-500/20 disabled:opacity-50'
          : 'inline-flex items-center gap-1 rounded-full bg-ink-800/5 px-2.5 py-1 text-xs font-medium text-ink-800/40 transition hover:bg-ink-800/10 disabled:opacity-50'
      }
    >
      <Icon className="size-3" aria-hidden />
      {label}
    </button>
  );
}
